export default {
  allowPhysicianRegistration: true,
  showPhysicians: true,
  showRealtors: false,
  refinerProjectId: '0c48c730-5746-11f0-af91-dba28993d717',
}
